<template>
  <div style="display: contents">
    <v-row dense>
      <v-col class="font-weight-bold"> Realização </v-col>
    </v-row>

    <v-row dense>
      <v-col v-if="surgery">
        <v-icon class="mb-1" color="green">
          eva-checkmark-circle-2
        </v-icon>
        <span> Enviado ao Bloco Cirúrgico em {{ formattedSurgeryDate }} </span>
        <v-btn class="px-1" color="blue darken-1" small text :to="surgeryUrl">
          (visualizar)
        </v-btn>
      </v-col>
      <v-col v-else>
        <v-icon class="mb-1" color="red">
          eva-close-circle
        </v-icon>
        <span> Não realizada </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    surgery: {
      type: Object,
      required: false,
    },
    attendanceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedSurgeryDate() {
      const date = this.$moment(this.surgery.createdAt);

      return date.format("DD/MM/YYYY à\\s HH:mm");
    },
    surgeryUrl() {
      return `/prontuario/${this.attendanceId}/cirurgia/${this.surgery.id}/detalhes`;
    },
  },
};
</script>
